const ROOT = 'CipReport/filter/paymentType';

export const FETCH_PAYMENT_TYPE_REQUEST = `${ROOT}/FETCH_PAYMENT_TYPE_REQUEST`;
export const FETCH_PAYMENT_TYPE_SUCCESS = `${ROOT}/FETCH_PAYMENT_TYPE_SUCCESS`;
export const FETCH_PAYMENT_TYPE_FAILURE = `${ROOT}/FETCH_PAYMENT_TYPE_FAILURE`;
export const FETCH_REFRESHTOKEN_REQUEST = `${ROOT}/FETCH_REFRESHTOKEN_REQUEST`;
